import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { headerWithAuthToken } from "../headers";
import { getAllTransactions, getSingleTransaction } from "./queries";

const transactionsApi = createApi({
    reducerPath: "transactionsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: adminBaseUrl,
        prepareHeaders: headerWithAuthToken,
    }),
    endpoints: (builder) => ({
        getAllTransactions: builder.query({
            providesTags: ["all_transactions"],
            query: getAllTransactions,
        }),

        getSingleTransaction: builder.query({
            providesTags: ["transaction"],
            query: getSingleTransaction,
        }),
    }),
});

export const {
    useGetAllTransactionsQuery,
    useGetSingleTransactionQuery,
    reducer: transactionsApiReducer,
    reducerPath: transactionsApiReducerPath,
    middleware: transactionsApiMiddleWare,
} = transactionsApi;
